(function () {
	'use strict';

	angular.module('dcApp').controller('NewMediaController', [
		'$scope',
		'$state',
		function ($scope, $state) {
			$scope.selectMediaType = function (type) {
				$state.go('medias-new', { type: type });
			};

			$scope.returnToList = function () {
				$state.go('medias', {});
			};
		},
	]);
})();
